import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SignOutRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SignOutResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const signOut = (request: SignOutRequest, options?: CashRequestOptions) =>
  post<SignOutRequest, SignOutResponse>('/2.0/cash/sign-out', request, { ...options, rejectOnError: true })
